import {sortAlphabetically} from "./formatters";

export const getColumns = (type: string) => {
	if (type === "list") {
		return sortAlphabetically(getStoryColumns(), 'title');
	}

	return sortAlphabetically(getVideoColumns(), 'title');
}

export const getStoryColumns = () => {
    return [
        {
            "name": "title",
            "title": "Title"
        },
        {
            "name": "section",
            "title": "Section"
        },
        {
            "name": "brandName",
            "title": "Brand"
        },
        {
            "name": "webPageviews",
            "title": "Web page views"
        },
        {
            "name": "appPageviews",
            "title": "App page views"
        },
        {
            "name": "totalPageviews",
            "title": "Total page views"
        },
        {
            "name": "conversion",
            "title": "Conversion"
        },
        {
            "name": "averageReadingTime",
            "title": "Avg. reading time"
        },
        {
            "name": "totalReadingTime",
            "title": "Total reading time"
        },
        {
            "name": "averageReadDepth",
            "title": "Avg. read depth"
        },
        {
            "name": "averageScrollDepth",
            "title": "Avg. scroll depth"
        },
        {
            "name": "facebookConsumptions",
            "title": "Facebook consumptions"
        },
        // {
        //     "name": "androidPageviews",
        //     "title": "Android page views" TODO version 2.0
        // },
        // {
        //     "name": "iosPageviews",
        //     "title": "IOS page views" TODO version 2.0
        // },
        {
            "name": "facebookLikes",
            "title": "Facebook likes"
        },
        {
            "name": "facebookComments",
            "title": "Facebook comments"
        },
        {
            "name": "facebookShares",
            "title": "Facebook shares"
        },
        {
            "name": "facebookLinkClicks",
            "title": "Facebook link clicks"
        },
        {
            "name": "facebookSocialScore",
            "title": "Facebook social score"
        },
        {
            "name": "socialActions",
            "title": "Social actions"
        },
        {
            "name": "twitterLikes",
            "title": "Twitter likes"
        },
        {
            "name": "twitterReply",
            "title": "Twitter replies"
        },
        {
            "name": "twitterScore",
            "title": "Twitter score"
        },
        // TODO: replace active users with total visitors
        // {
        //     "name": "totalVisitors",
        //     "title": "Total visitors"
        // },
        {
            "name": "webVisitors",
            "title": "Web visitors"
        },
        {
            "name": "appVisitors",
            "title": "App visitors"
        },
    ];
};

export const getVideoColumns = () => {
	return [
		{
			"name": "title",
			"title": "Title"
		},
        {
            "name": "brandName",
            "title": "Brand"
        },
		{
			"name": "total",
			"title": "Total video views"
		},
		{
			"name": "totalWeb",
			"title": "Total web video views"
		},
		{
			"name": "totalApp",
			"title": "Total app video views"
		}
	];
}

export const goalColumns = {
	title: "Title",
	total: "Total page views",
	totalWeb: "Web page views",
    totalApp: "App page views",
    readingTimeTotal: "Total Reading time",
};

export const goalVideoColumns = {
	title: "Title",
	total: "Total video views",
	totalWeb: "Total web video views",
	totalApp: "Total app video views",
};
